/* eslint-disable max-lines */
import styled from 'styled-components';

// ============================================================================
// BADGE (trigger na liście)
// ============================================================================

export const BadgeButton = styled.button<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
  border: 1px solid;
  background: ${(props) => `${props.$color}10`};
  border-color: ${(props) => `${props.$color}40`};
  color: ${(props) => props.$color};
  font-size: 0.75rem;
  font-weight: 300;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }
`;

export const EmojiSpan = styled.span`
  font-size: 0.75rem;
`;

export const ScoreSpan = styled.span`
  font-size: 0.75rem;
  font-weight: 300;
`;

// ============================================================================
// MODAL — "Ocena jakości treści AI": proste, czytelne podsumowanie (bez kafelków)
// ============================================================================

export const PopoverContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 1.75rem;
  background: ${({ theme }) => theme.colors.card.background};

  @media (max-width: 640px) {
    padding: 1.5rem;
    min-height: 100%;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.secondary};

  &:hover {
    background-color: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)')};
  }
`;

// ------------------------------- HEADER -------------------------------------

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-right: 2rem;
  margin-bottom: 1.5rem;
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
  flex: 1;
`;

export const Title = styled.h3`
  font-size: 1.0625rem;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  line-height: 1.3;
`;

export const Grade = styled.span<{ $color: string }>`
  font-size: 0.9375rem;
  font-weight: 300;
  color: ${(props) => props.$color};
`;

// ----------------------- PIERŚCIEŃ WYNIKU (donut) ---------------------------

export const RingWrap = styled.div`
  position: relative;
  width: 84px;
  height: 84px;
  flex-shrink: 0;
`;

export const RingTrack = styled.circle`
  fill: none;
  stroke: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.1)' : '#eef1f4')};
`;

export const RingProgress = styled.circle<{ $color: string }>`
  fill: none;
  stroke: ${(props) => props.$color};
  stroke-linecap: round;
  transition: stroke-dashoffset 0.8s ease;
`;

export const RingCenter = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const RingScore = styled.span<{ $color: string }>`
  font-size: 1.625rem;
  font-weight: 500;
  line-height: 1;
  color: ${(props) => props.$color};
`;

export const RingMax = styled.span`
  font-size: 0.75rem;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 0.125rem;
`;

// ------------------------------ PODSUMOWANIE --------------------------------

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.875rem;
  padding: 0.75rem 0;
  border-top: 1px solid ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.06)' : '#f0f2f4')};

  &:first-child {
    border-top: none;
  }
`;

export const RowLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 38%;
  flex-shrink: 0;
  font-size: 0.9375rem;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.text.primary};

  span:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const RowEmoji = styled.span`
  font-size: 1.0625rem;
  line-height: 1;
  flex-shrink: 0;
`;

export const RowFeedback = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const RowPoints = styled.span<{ $color: string }>`
  flex-shrink: 0;
  font-size: 0.9375rem;
  font-weight: 400;
  color: ${(props) => props.$color};
  white-space: nowrap;
`;

export const RowPointsMax = styled.span`
  font-size: 0.8125rem;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
